
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shaastra-upskill-teacher-mentoring-program",
      function () {
        return require("private-next-pages/shaastra-upskill-teacher-mentoring-program.tsx");
      }
    ]);
  